"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ConsultationBanner() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="patconsultationbanner" data-nav="dark" className="relative w-full bg-sidebar text-sidebar-foreground py-16 md:py-20 lg:py-24 overflow-hidden">
      {/* Subtle decorative background pattern elements */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden opacity-10">
        <div className="absolute -top-24 -left-24 size-96 rounded-full bg-sidebar-primary/20 blur-3xl" />
        <div className="absolute -bottom-24 -right-24 size-96 rounded-full bg-sidebar-accent blur-3xl" />
      </div>

      <div className="page-container relative z-10">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 20
      }} whileInView={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="mx-auto max-w-3xl text-center flex flex-col items-center justify-center gap-6">
          <h2 className="font-default text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-sidebar-foreground leading-tight">
            Speak With Our Process Analytical Technology Specialists
          </h2>

          <p className="text-base sm:text-lg text-sidebar-foreground/80 max-w-2xl font-normal leading-relaxed">
            Get practical guidance on PAT implementation, qualification protocols, and continuous process monitoring tailored to your regulated laboratory or manufacturing line.
          </p>

          <div className="pt-2">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-md font-semibold px-8 py-6 text-base rounded-md transition-transform hover:scale-[1.02] active:scale-[0.98]">
              <Link to="/ContactPage" className="inline-flex items-center gap-2">
                <span>Contact Our PAT Experts</span>
                <ArrowRight className="size-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}